export const createDefaultReportName = (conversionName, customerType, attributionModel) => `${conversionName} - ${customerType} - ${attributionModel}`;
